import CustomerOrderDetails from './CustomerOrderDetails'

export * from './CustomerOrderDetails'

export default CustomerOrderDetails
